import { createTranslations } from '@npco/utils-translations'

export const setupFlowDebitCardSensitiveInformationTranslations =
  createTranslations({
    ownerLabel: 'Name',
    panLabel: 'Card No.',
    cvcLabel: 'CVC',
    expiryLabel: 'Expiry',
  })
